/**
 * @typedef {Object} MedicalDocumentState
 * @property {Record<string, Record<string, any>>} data
 * @property {string} currentStep
 */

/** @type {MedicalDocumentState} */
export default {
  data: {},
  currentStep: null,
}
